import React from "react";
import { MenuItem, TextField, InputAdornment } from "@mui/material";
import { Search } from "@mui/icons-material";
import { searchMenuItemStyles, searchTextFieldStyles } from "../styles/MultiSelectSearch.styles";
import type { MultiSelectSearchProps } from "../types/types";

export const MultiSelectSearch: React.FC<MultiSelectSearchProps> = ({
  placeholder,
  searchTerm,
  onSearchChange,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSearchChange(e.target.value);
  };

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <MenuItem disableRipple sx={searchMenuItemStyles}>
      <TextField
        size="small"
        placeholder={placeholder}
        variant="outlined"
        value={searchTerm}
        onChange={handleChange}
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search sx={{ fontSize: "20px" }} />
            </InputAdornment>
          ),
        }}
        sx={searchTextFieldStyles}
        onClick={handleClick}
      />
    </MenuItem>
  );
}; 